<button
  (click)="writeReviewDialogService.openWriteAReviewDialog(g2Product)"
  (keyup.enter)="writeReviewDialogService.openWriteAReviewDialog(g2Product)"
  class="btn btn-primary"
  id="review-open-write-review-modal">
  {{ btnLabel }}
</button>
